/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PartnerNumberDto } from '../../models/partner-number-dto';

export interface UpdatePartnerNumber$Params {
  id: number;
      body: PartnerNumberDto
}

export function updatePartnerNumber(http: HttpClient, rootUrl: string, params: UpdatePartnerNumber$Params, context?: HttpContext): Observable<StrictHttpResponse<PartnerNumberDto>> {
  const rb = new RequestBuilder(rootUrl, updatePartnerNumber.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PartnerNumberDto>;
    })
  );
}

updatePartnerNumber.PATH = '/partnerNumber/{id}';
